import React from 'react';
import { MessageCircle, Phone } from 'lucide-react';

const ChatWidgets = () => {
  return (
    <div className="fixed bottom-6 right-6 flex flex-col gap-3 z-50">
      {/* WhatsApp Widget */}
      <button
        onClick={() => window.open('https://wa.me/[YOUR_WHATSAPP_NUMBER]', '_blank')}
        className="bg-[#25D366] text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 group"
        aria-label="Chat on WhatsApp"
      >
        <Phone className="w-6 h-6" />
        <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-gray-900 text-white px-3 py-2 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
          Chat on WhatsApp
        </span>
      </button>

      {/* Zalo Widget */}
      <button
        onClick={() => window.open('https://zalo.me/[YOUR_ZALO_ID]', '_blank')}
        className="bg-[#0068FF] text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 group"
        aria-label="Chat on Zalo"
      >
        <MessageCircle className="w-6 h-6" />
        <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-gray-900 text-white px-3 py-2 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
          Chat on Zalo
        </span>
      </button>
    </div>
  );
};

export default ChatWidgets;
